import { loadStripe, Stripe } from '@stripe/stripe-js'

import { APP } from 'src/Configs/App'

let stripePromise: Promise<Stripe | null> | null = null

export const getStripePromise = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = APP.STRIPE_PUBLISHABLE_KEY
      ? loadStripe(APP.STRIPE_PUBLISHABLE_KEY)
      : Promise.resolve(null)
  }

  return stripePromise
}
